<template>
  <div class="financeManage-orderDetail-page">
    <p class="hasBottomLine">订单详情</p>

    <div class="mokuai">
      <p class="setBlockTitle">1.订单基本信息</p>
      <div class="line-box">
        <div class="lineItem">
          <p class="itemtop">订单编号</p>
          <div class="itemMain">{{ orderDetail.id }}</div>
        </div>
        <div class="lineItem">
          <p class="itemtop">下单用户账户</p>
          <div class="itemMain">{{ orderDetail.userId }}</div>
        </div>
        <div class="lineItem">
          <p class="itemtop">抵押币种</p>
          <div class="itemMain">{{ orderDetail.mortgageCoin }}</div>
        </div>
        <div class="lineItem">
          <p class="itemtop">抵押质押率</p>
          <div class="itemMain">{{ orderDetail.mortgageRate }}</div>
        </div>
      </div>

      <div class="line-box">
        <div class="lineItem">
          <p class="itemtop">抵押数量</p>
          <div class="itemMain">{{ orderDetail.mortgageAmount }}</div>
        </div>
        <div class="lineItem">
          <p class="itemtop">借贷币种</p>
          <div class="itemMain">{{ orderDetail.borrowCoin }}</div>
        </div>
        <div class="lineItem">
          <p class="itemtop">借贷数量</p>
          <div class="itemMain">{{ orderDetail.borrowAmount }}</div>
        </div>
        <div class="lineItem">
          <p class="itemtop">计息方式</p>
          <div class="itemMain">
            <span v-if="orderDetail.interestType == 0">按日计息</span>
            <span v-if="orderDetail.interestType == 1">按时计息</span>
            <span v-if="orderDetail.interestType == 2">按日计息,按时计息</span>
          </div>
        </div>
      </div>

      <div class="line-box">
        <div class="lineItem">
          <p class="itemtop">利率</p>
          <div class="itemMain">{{ orderDetail.interestRate }}</div>
        </div>
        <div class="lineItem">
          <p class="itemtop">借贷时长/天数</p>
          <div class="itemMain">{{ orderDetail.borrowDay }}</div>
        </div>
        <div class="lineItem">
          <p class="itemtop">借贷利息</p>
          <div class="itemMain">{{ orderDetail.interestAmount }}</div>
        </div>
        <div class="lineItem">
          <p class="itemtop">最长借贷周期</p>
          <div class="itemMain">{{ orderDetail.borrowDay }}</div>
        </div>
      </div>

      <div class="line-box">
        <div class="lineItem">
          <p class="itemtop">下单时间</p>
          <div class="itemMain">{{ orderDetail.createTime | moment }}</div>
        </div>
        <div class="lineItem">
          <p class="itemtop">审核时间</p>
          <div class="itemMain">
            <span v-if="orderDetail.auditTime">{{ orderDetail.auditTime | moment }}</span>
            <span v-else>--</span>
          </div>
        </div>
        <div class="lineItem">
          <p class="itemtop">审核不通过理由</p>
          <div class="itemMain">
            <span>{{ orderDetail.reason || "--" }}</span>
          </div>
        </div>
        <div class="lineItem">
          <p class="itemtop">订单状态</p>
          <div class="itemMain">
            <span v-if="orderDetail.status == 0">审核中</span>
            <span v-if="orderDetail.status == 1">贷款中</span>
            <span v-if="orderDetail.status == 2">已完成</span>
            <span v-if="orderDetail.status == 3">已取消</span>
            <span v-if="orderDetail.status == 4"> 强平中</span>
            <span v-if="orderDetail.status == 5">已强平</span>
          </div>
        </div>
      </div>

      <div class="line-box">
        <div class="lineItem">
          <p class="itemtop">创建订单时指数价格</p>
          <div class="itemMain">--</div>
        </div>
        <div class="lineItem">
          <p class="itemtop">备注</p>
          <div class="itemMain">{{ orderDetail.remark || "--" }}</div>
        </div>
        <div class="lineItem">
          <p class="itemtop"></p>
          <div class="itemMain"></div>
        </div>
        <div class="lineItem">
          <p class="itemtop"></p>
          <div class="itemMain"></div>
        </div>
      </div>
    </div>

    <div class="mokuai">
      <p class="setBlockTitle">2.订单还款信息</p>
      <div class="line-box">
        <div class="lineItem">
          <p class="itemtop">应还金额（借贷本金+利息）</p>
          <div class="itemMain">{{ orderDetail.interestAmount + orderDetail.borrowAmount }}</div>
        </div>
        <div class="lineItem">
          <p class="itemtop">还款时间</p>
          <div class="itemMain">{{ orderDetail.expireTime | moment }}</div>
        </div>
        <div class="lineItem">
          <p class="itemtop">还款方式</p>
          <div class="itemMain">目前随借随还</div>
        </div>
        <div class="lineItem">
          <p class="itemtop">还款金额</p>
          <div class="itemMain">{{ orderDetail.returnAmount }}</div>
        </div>
      </div>
    </div>

    <div class="mokuai">
      <p class="setBlockTitle">3.订单强平信息</p>
      <div class="line-box">
        <div class="lineItem">
          <p class="itemtop">强平时间</p>
          <div class="itemMain">
            <span v-if="orderDetail.blastDetailVO && orderDetail.blastDetailVO.blastTime">
              {{ orderDetail.blastDetailVO.blastTime | moment }}</span
            >
            <span v-else>--</span>
          </div>
        </div>
        <div class="lineItem">
          <p class="itemtop">触发强平类型</p>
          <div class="itemMain" v-if="orderDetail.blastDetailVO">
            <span v-if="orderDetail.blastDetailVO.blastType == 0">增加抵押物</span>
            <span v-if="orderDetail.blastDetailVO.blastType == 1">正常还款</span>
            <span v-if="orderDetail.blastDetailVO.blastType == 2">到期强平</span>
            <span v-if="orderDetail.blastDetailVO.blastType == 3">风险率强平</span>
          </div>
        </div>
        <div class="lineItem">
          <p class="itemtop">强平订单编号</p>
          <div class="itemMain" v-if="orderDetail.blastDetailVO">
            <span class="btnStyle" v-if="orderDetail.blastDetailVO.blastId" @click="toGoBlastList(orderDetail.blastDetailVO.blastId)">{{ orderDetail.blastDetailVO.blastId}}</span>
             <span v-else>--</span>
          </div>
        </div>
      </div>
    </div>

    <div class="mokuai">
      <p class="setBlockTitle">4.用户增加抵押物记录</p>
      <div class="line-box">
        <div class="lineItem">
          <p class="itemtop">抵押币种</p>
        </div>
        <div class="lineItem">
          <p class="itemtop">增加抵押物数量</p>
        </div>
        <div class="lineItem">
          <p class="itemtop">用户账户</p>
        </div>
        <div class="lineItem">
          <p class="itemtop">操作时间</p>
        </div>
      </div>
      <div v-if="orderDetail.list && orderDetail.list.length > 0">
        <div class="line-box" v-for="item in orderDetail.list" :key="item.createTime">
          <div class="lineItem">
            <div class="itemMain">{{ item.coinType }}</div>
          </div>
          <div class="lineItem">
            <div class="itemMain">{{ item.amount }}</div>
          </div>
          <div class="lineItem">
            <div class="itemMain">{{ item.userId }}</div>
          </div>
          <div class="lineItem">
            <div class="itemMain">{{ item.createTime | moment }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../store";
import api from "../api";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "System",
  data() {
    return {
      shareTime: new Date(),
      list: [
        { amount: "45", coinType: "btc", createTime: "22", userId: "222" },
        { amount: "45", coinType: "btc", createTime: "22", userId: "222" },
        { amount: "", coinType: "", createTime: "", userId: "" }
      ]
    };
  },
  computed: {
     ...mapState("FinanceManage", ["orderDetail"])
  },
  methods: {
    ...mapActions("FinanceManage", ["getOrderDetail"]),
    handleSearch() {},

    toGoBlastList(blastId){
      this.$router.push("/home/finance/manage/mortgage/blastList?blastId=" + blastId)
    }
  },
  created() {},
  mounted() {
    let that = this;
    this.getOrderDetail({
      orderId: that.$route.query.id
    });
  }
};
</script>

<style lang="less">
.financeManage-orderDetail-page {
  width: 100%;
  height: 500px;
  .hasBottomLine {
    width: 100%;
    padding-bottom: 18px;
    font-size: 18px;
    margin-bottom: 18px;
    font-weight: bold;
    border-bottom: 1px solid #cccccc;
  }

  .mokuai {
    margin-bottom: 50px;
    .setBlockTitle {
      padding-bottom: 18px;
      font-size: 16px;
      margin-bottom: 18px;
    }

    .line-box {
      display: flex;
      width: 100%;
      .lineItem {
        width: 24%;
        text-align: center;
        border: 1px solid #cccccc;
        .itemtop {
          background: #f2f2f2;
          font-size: 16px;
          font-weight: bold;
          height: 50px;
          line-height: 40px;
          margin: 0;
          padding: 0;
        }
        .itemMain {
          font-size: 16px;
          height: 70px;
          line-height: 70px;
          background: #ffffff;
          .btnStyle{
            color: #409EFF;
            cursor: pointer;
          }
        }
      }

      .lineItem:nth-child(odd) {
        border-bottom: none;
        border-right: none;
      }
      .lineItem:nth-child(2) {
        border-bottom: none;
        border-right: none;
      }
    }
  }
}
</style>
